export default __webpack_public_path__ + "static/media/raindrop.084505a2.png";